const WEEKDAY = 'weekday'
const FRIDAY = 'friday'
const SATURDAY = 'saturday'

export const TYPE_DAY = [WEEKDAY, FRIDAY, SATURDAY]
